import { appConfig } from '@/config';

const OBJECT_PATH_PREFIX = '/object/';

export function toPortableObjectPath(value) {
  const source = String(value || '').trim();
  if (!source) {
    return source;
  }
  if (source.startsWith(OBJECT_PATH_PREFIX)) {
    return appConfig.capacitorApp ? new URL(source, appConfig.serviceOrigin).href : source;
  }
  try {
    const url = new URL(source);
    if ((url.protocol === 'http:' || url.protocol === 'https:') && url.pathname.startsWith(OBJECT_PATH_PREFIX)) {
      const path = `${url.pathname}${url.search}${url.hash}`;
      return appConfig.capacitorApp ? new URL(path, appConfig.serviceOrigin).href : path;
    }
  } catch (error) {
    return source;
  }
  return source;
}
